module.exports = __webpack_public_path__ + "static/img-walter-white-d3da5a21a1584e7f521d839164306198.jpg";